import md5 from "md5";
import { LobbyUser } from "~/utils";

export const getGravatarUrl = (user: LobbyUser, size: number) => {
  const { id, name } = user;
  const usedString = name === "anonymous" ? id : name;
  const md5String = md5(usedString);
  return `http://www.gravatar.com/avatar/${md5String}?d=identicon&r=g&s=${size}`;
};
